import { useQueryClient } from "@tanstack/react-query";

import { updateFieldsForEvent } from "@/hooks/useInfiniteMessages";
import { useUpdateOngoingCuraiVisitFromAnotherNoriConversation } from "../generated";

export const useUpdateCuraiVisit = (
  conversationId: string,
  messageId: string,
) => {
  const queryClient = useQueryClient();
  return useUpdateOngoingCuraiVisitFromAnotherNoriConversation({
    mutation: {
      onSuccess: () =>
        updateFieldsForEvent(queryClient, conversationId as string, messageId, {
          content: { action_taken: "visit_updated" },
        }),
    },
  });
};
